import React from 'react';
import colors from '../styles/colors';

const StatCard = ({ title, value, subtitle, color }) => {
  return (
    <div style={styles.card}>
      <div style={{ ...styles.accent, background: color || colors.brandPrimary }}></div>
      <div style={styles.body}>
        <div style={styles.title}>{title}</div>
        <div style={{ ...styles.value, color: color || colors.brandPrimary }}>{value}</div>
        {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
      </div>
    </div>
  );
};

const styles = {
  card: {
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  accent: {
    height: '3px',
    width: '100%'
  },
  body: {
    padding: '24px 20px'
  },
  title: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: '#666',
    marginBottom: '8px'
  },
  value: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '36px',
    fontWeight: '700',
    lineHeight: '1',
    marginBottom: '6px'
  },
  subtitle: {
    fontSize: '12px',
    color: '#999',
    marginTop: '4px'
  }
};

export default StatCard;